// /forms/user/validators.js
export const validateField = (name, value, rules) => {
  const fieldRule = rules[name];

  if (!fieldRule) return null;

  // Convert value to string safely
  const valueStr =
    typeof value === "string" ? value.trim() : String(value ?? "").trim();

  if (fieldRule.required && !valueStr) {
    return "This field is required.";
  }

  // if (fieldRule.required && !value.trim()) {
  //   return "This field is required.";
  // }

  if (fieldRule.pattern && !fieldRule.pattern.test(valueStr)) {
    return fieldRule.message || "Invalid value.";
  }
  if (typeof fieldRule.validate === "function") {
    const result = fieldRule.validate(valueStr);
    if (result !== true) return result || "Invalid value.";
  }

  return "";
};

export const validateForm = (formData, rules) => {
  let isValid = true;
  const errors = {};
  Object.keys(rules).forEach((name) => {
    const value = formData[name] || "";
    const error = validateField(name, value, rules);
    if (error) {
      isValid = false;
      errors[name] = error;
    }
  });

  return { isValid, errors };
};

export const validateFlightForm = (flightData) => {
  let isValid = true;
  const errors = [];
  // const requiredFields = [
  //   "airportFrom",
  //   "airportTo",
  //   "airline",
  //   "flightNumber",
  //   "departureDate",
  //   "departureTime",
  //   "arrivalDate",
  //   "arrivalTime",
  // ];

  flightData.forEach((flight, index) => {
    const error = {};

    // Required field check
    // requiredFields.forEach((field) => {
    //   if (!flight[field] || flight[field].toString().trim() === "") {
    //     error[field] = `This field is required`;
    //   }
    // });

    // Validate arrival date >= departure date
    const { departureDate, arrivalDate, flightBoundConfirmation } = flight;
    if (!flightBoundConfirmation)
      if (
        departureDate &&
        arrivalDate &&
        new Date(arrivalDate) < new Date(departureDate)
      ) {
        // error["flightBoundConfirmation"] = "This field is required";
        error["arrivalDate"] = "Arrival date cannot be before departure date";
      }

    if (Object.keys(error).length > 0) {
      isValid = false;
      errors[index] = error;
    } else {
      errors[index] = null;
    }
  });

  return { isValid, errors };
};

export const validateFlightField = (fieldName, value, allValues = {}) => {
  // if (!value || value.toString().trim() === "") {
  //   return "This field is required";
  // }

  // Additional validations per field
  if (fieldName === "arrivalDate" && allValues["departureDate"]) {
    if (value < allValues["departureDate"]) {
      return "Arrival date cannot be before departure date";
    }
  }

  return "";
};
